"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("./SvgIcon"));
var CheckIcon = function (props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M8.9999298,15.0402985 L5.47424862,11.1944838 C4.72782413,10.3802836 3.46268813,10.3253408 2.64848829,11.0717656 C1.83428845,11.8181904 1.77934568,13.083327 2.52577018,13.8975272 L7.52576429,19.3515232 C8.31845278,20.2161882 9.68166465,20.2161542 10.4743101,19.3514497 L21.4742971,7.35145857 C22.2206811,6.53722119 22.1656753,5.27208738 21.3514382,4.52570311 C20.5372012,3.77931885 19.272068,3.83432467 18.525684,4.64856205 L8.9999298,15.0402985 Z" })));
};
exports.default = CheckIcon;
